// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3u4hR","empty":"ModalGraph_empty__1zCN0"};